import api from '@/libs/axios'
import { PaginatedList } from '../models/common/paginatedList'
import { MoyenLocomotion } from '../models/options/moyensLocomotion/moyenLocomotion';

const resource = 'MoyensLocomotion'

export default class MoyensLocomotionRessource {
  public async paginatedList(pagenumber?: number, pagesize?: number, actifonly?: boolean): Promise<PaginatedList<MoyenLocomotion>> {
    const params = new URLSearchParams();
    if (pagenumber) params.append('PageNumber', pagenumber.toString());
    if (pagesize) params.append('PageSize', pagesize.toString());
    if (actifonly) params.append('ActifOnly', actifonly.toString());

    const response = await api.get(`${resource}`, { params: params })
    return response.data
  }
}
